import React,{useState, useEffect, useContext} from "react";
import Global from '../../APIConfig';
import { useNavigate,Link } from "react-router-dom";
import AuthUser from "../../AuthUser";
import axios from 'axios';
import { AppContext } from '../../context/AppContext';

function MasterLeftPanel()
{
    let navigate = useNavigate();
    const{headers1,headers2,logout}=AuthUser();
    const[show,SetShow]=useState('close');
    const items = JSON.parse(localStorage.getItem('user'));
    const user_privilage_string = items.user_privilage_array;
    const user_privilage_array = user_privilage_string.split(',').map(Number);
    // const [companyname, setCompanyname] = useState('Consolidix Logistics');
    const [loading, setloading] = useState(false);
    const [DropdownType, setDropdownType] = useState('');
    const { companyname } = useContext(AppContext);
    
    const userlogout=()=>{
      logout();
      navigate('/');
    }
    return (
        <div className={`sidebar ${show}`}>
          <div className="logo-details">
            <div className="head_icon" onClick={()=>{SetShow(show=='close'?'show':'close')}}>
                <i className="bx bx-menu"></i>
            </div>
            <span className="logo_name">{companyname}</span>
          </div>
          <ul className="nav-links">
          <li className={DropdownType=='dashboard'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='dashboard'?setDropdownType('dashboard'):setDropdownType('')}}>
                  <i className="bx bx-grid-alt"></i>
                  <span className="link_name">Dashboard</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Dashboard</a></li>
                <li><a href="/Admin-Dash">Master Dashboard</a></li>
              </ul>
            </li>
            {items.usertype =='AD' ?
            <li className={DropdownType=='price-master'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='price-master'?setDropdownType('price-master'):setDropdownType('')}}>
                  <i className="bx bx-dollar"></i>
                  <span className="link_name">Price Master</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Price Master</a></li>
                <li><a href="/ServiceList/All">All Services</a></li>
                <li><a href="/ServiceList/Domestic">Domestic Services</a></li>
                <li><a href="/ServiceList/International">International Services </a></li>
                {/* <li><a href=".php">Other Charges Master</a></li> */}
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || user_privilage_array.includes(16) ?
            <li className={DropdownType=='zones'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='zones'?setDropdownType('zones'):setDropdownType('')}}>
                  <i className="bx bx-map-alt"></i>
                  <span className="link_name">Zones</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu ">
                <li><a className="link_name" href="#">Shipping Zones Management</a></li>
                <li><a className="" href="/zoneList/All">All Zones</a></li>
                <li><a className="" href="/ZoneSetList/Domestic">Domestic Zones Cities</a></li>
                <li><a className="" href="/ZoneSetList/International">International Zones Countries</a></li>
                <li><a className="" href="/ZoneSetDomestic">Set Domestic City Zones</a></li>
                <li><a className="" href="/ZoneSetInternational">Set International Country Zones</a></li>
              </ul>
            </li>
            :
            ""
            }
            
            {items.usertype =='AD' || items.usertype =='M' ||user_privilage_array.includes(17) ?
            <li className={DropdownType=='routes'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='routes'?setDropdownType('routes'):setDropdownType('')}}>
                  <i className="bx bx-flag"></i>
                  <span className="link_name">Routes</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Shipping Routes Management</a></li>
                <li><a href="/Routelist/All">All Routes</a></li>
                <li><a href="/RouteAdd">Add New Route</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || user_privilage_array.includes(18) ?
            <li className={DropdownType=='location-management'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='location-management'?setDropdownType('location-management'):setDropdownType('')}}>
                  <i className="bx bx-map"></i>
                  <span className="link_name">Location Management</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Location Management</a></li>
                <li><a href="/Countrylist">All Countries</a></li>
                <li><a href="/CountryAdd">Add Country</a></li>
                <li><a href="/ImportLocation">Import Country/State/City</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || user_privilage_array.includes(19) ?
            <li className={DropdownType=='pincode-management'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='pincode-management'?setDropdownType('pincode-management'):setDropdownType('')}}>
                  <i className="bx bx-map-pin"></i>
                  <span className="link_name">Pincode Management</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">Pincode Management</a></li>
                <li><a href="/Pincodelist">All Pincodes</a></li>
                <li><a href="/ImportPincode">Import Pincodes</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || user_privilage_array.includes(21) ?
            <li className={DropdownType=='cms-management'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='cms-management'?setDropdownType('cms-management'):setDropdownType('')}}>
                  <i className="bx bx-book"></i>
                  <span className="link_name">CMS Management</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu">
                <li><a className="link_name" href="#">CMS Management</a></li>
                <li><a href="/CmsList">All CMS</a></li>
              </ul>
            </li>
            :
            ""
            }
            {items.usertype =='AD' || user_privilage_array.includes(14) ?
            <li className={DropdownType=='setting'?`showMenu`:''}>
              <div className="iocn-link">
                <a href="#" onClick={()=>{DropdownType!='setting'?setDropdownType('setting'):setDropdownType('')}}>
                  <i className="bx bx-cog"></i>
                  <span className="link_name">Settings</span>
                </a>
                <i className="bx bxs-chevron-down arrow"></i>
              </div>
              <ul className="sub-menu" style={{"top": "-100px;"}}>
                <li><a className="link_name" href="/Settings">Settings</a></li>
                <li><a href="/Settings">Setting</a></li>
              </ul>
            </li>
            :
            ""
            }
            <li>
            <div className="profile-details">
                <div className="profile-content">
                <img src={`${Global.logoUrl}${items.profile_image}`} alt="profileImg" />
                </div>
                <div className="name-job">
                <div className="profile_name">{items.name}</div>
                <div className="job">{items.company}</div>
                </div>
                <i className="bx bx-log-out" onClick={()=>userlogout()}></i>
            </div>
            </li>
      </ul>
    </div>
    );

}
export default MasterLeftPanel;